import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export class ExpertProfileConversationStartedEvent extends Event {
  static displayName = 'Expert Profile Conversation Started'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
